export default __webpack_public_path__ + "static/logo-1c64d8c694ba7c0fc734893a05571011.png";